import { AppPageLayout } from "@/components/common/AppPageLayout";
import Stepper from "@/components/common/Stepper";
import { useTemplateNavigationStore } from "@/features/templates/hooks/useTemplateNavigationStore";
import { hooks as h } from "@/hooks";
import { createFileRoute, Outlet, useRouter } from "@tanstack/react-router";
import { useEffect, useMemo } from "react";

const NewDiaryFormLayout = () => {
    const { templateId } = Route.useParams();
    const router = useRouter();
    const currentPath = router.state.location.pathname;
    const { steps, setCurrentStep } = useTemplateNavigationStore();

    h.useNav([
        { label: "New Diary", route: { to: currentPath } },
        {
            label: "Template",
            route: {
                to: Route.to,
                params: { templateId: templateId },
            },
        },
    ]);

    // Memoize the route to step index mapping
    const routeToStepIndex = useMemo(
        () => ({
            "/templates/diary/$templateId/trackers": 0,
            "/templates/diary/$templateId/events": 1,
            "/templates/diary/$templateId/events/injection": 1,
            "/templates/diary/$templateId/events/injection/details": 1,
            "/templates/diary/$templateId/name": 2,
        }),
        []
    );

    // Update current step based on route
    useEffect(() => {
        const stepIndex = routeToStepIndex[currentPath];
        if (stepIndex !== undefined) {
            setCurrentStep(stepIndex);
        }
    }, [currentPath, routeToStepIndex, setCurrentStep]);

    return (
        <AppPageLayout width="md" padding="none" as="div" className="space-y-6">
            <Stepper steps={steps} />
            <Outlet />
        </AppPageLayout>
    );
};

export const Route = createFileRoute("/_app/templates/diary/$templateId")({
    component: NewDiaryFormLayout,
});
